import React, { useEffect, useRef } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['link', 'image'],
        ['clean'],
      ],
    },
    formats: [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'color', 'background',
        'align',
        'link', 'image'
    ],
    placeholder: placeholder,
  });

  const isInternalChange = useRef(false);

  useEffect(() => {
    if (quill) {
      if (value && value !== quill.root.innerHTML && !isInternalChange.current) {
        quill.clipboard.dangerouslyPasteHTML(value);
      }

      quill.on('text-change', () => {
        isInternalChange.current = true;
        onChange(quill.root.innerHTML);
      });
      
      quill.getModule('toolbar').addHandler('image', () => {
         const input = document.createElement('input');
         input.setAttribute('type', 'file');
         input.setAttribute('accept', 'image/*');
         input.click();
         input.onchange = async () => {
           const file = input.files[0];
           if (file) {
             const reader = new FileReader();
             reader.onload = (e) => {
                const range = quill.getSelection(true);
                quill.insertEmbed(range.index, 'image', e.target.result);
                quill.setSelection(range.index + 1);
             };
             reader.readAsDataURL(file);
           }
         };
      });
    }
  }, [quill, onChange]);
  
  useEffect(() => {
    if(quill && value !== quill.root.innerHTML) {
         quill.clipboard.dangerouslyPasteHTML(value);
    }
  }, [quill, value]);


  return (
    <div style={{ width: '100%', height: '200px', marginBottom:'50px' }}>
      <div ref={quillRef} />
    </div>
  );
};

export default RichTextEditor;
